const staticPricingPlans = [
  {
    monthlyId: 'free',
    yearlyId: 'free',
    monthlyPrice: '$0/month',
    yearlyPrice: '$0/month',
    title: 'Free',
    description: 'Essential tools to get started',
    features: ['10 RodeoAI credits/month', '1 Portfolio', '1 Watchlist', 'Site alerts', 'Congress Tracker', 'Insider Tracker', 'Pre-made screeners', 'Custom screener', '5 Year Historical Data', 'Limited Access', '10 results limit'],
    btn: 'Get Started',
    id: 'free',
    isFree: true // Mark as free plan
  },
  {
    monthlyId: '',
    yearlyId: '',
    monthlyPrice: '$15/month',
    yearlyPrice: '$12/month',
    title: 'Basic',
    description: 'Enhanced features and tools',
    features: ['200 RodeoAI credits/month', '4 Portfolio', '4 Watchlist', 'Email & Telegram alerts', 'Congress Tracker', 'Insider Tracker', 'Pre-made screeners', 'Custom screener', '10 Year Historical Data', 'Company data', 'Financial data', 'More Access', '100 results limit', 'Market Calendars'],
    btn: 'Get Basic',
    isFree: false
  },
  {
    monthlyId: '',
    yearlyId: '',
    monthlyPrice: '$25/month',
    yearlyPrice: '$20/month',
    title: 'Premium',
    description: 'All features with full access',
    features: ['1000 RodeoAI credits/month', '10 Portfolio', '10 Watchlist', 'Discord & unlimited alerts', 'Congress Tracker', 'Insider Tracker', 'Pre-made screeners', 'Custom screener', '30+ Year Historical Data', 'Full company data', 'Full financial data', 'Market Calendars', 'Prioritized feature requests', 'Export Data'],
    btn: 'Get Premium',
    isFree: false
  }
];

export default staticPricingPlans;
